var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorSwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2664_5599)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62422 0.799988C1.18239 0.799988 0.824219 1.15816 0.824219 1.59999V5.99999C0.824219 6.66273 1.36148 7.19999 2.02422 7.19999C2.68696 7.19999 3.22422 6.66273 3.22422 5.99999V1.59999C3.22422 1.15816 2.86605 0.799988 2.42422 0.799988H1.62422ZM2.02422 6.39999C2.24513 6.39999 2.42422 6.2209 2.42422 5.99999C2.42422 5.77907 2.24513 5.59999 2.02422 5.59999C1.8033 5.59999 1.62422 5.77907 1.62422 5.99999C1.62422 6.2209 1.8033 6.39999 2.02422 6.39999Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02422 5.69701L5.98401 3.73722C6.29643 3.4248 6.29643 2.91827 5.98401 2.60585L5.41833 2.04016C5.10591 1.72774 4.59938 1.72774 4.28696 2.04016L4.02422 2.3029V5.69701Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42423 7.19999H3.65264L6.05264 4.79999H6.42423C6.86606 4.79999 7.22423 5.15816 7.22423 5.59999V6.39999C7.22423 6.84181 6.86606 7.19999 6.42423 7.19999Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2664_5599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(0.0244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorSwatch);
export default __webpack_public_path__ + "static/media/color-swatch.8785e1d0d2d2c3b1173fe666e3fd8045.svg";
export { ForwardRef as ReactComponent };